import React from "react";
import useFetchData from "../../hooks/useFetchData";
import PositionedScreen from "../../Pages/FlexibleLayout/PositionedScreen";
import { convertGridToPixels } from "../../Pages/FlexibleLayout/utils";

const ActivityCardPreview = ({ config, classes }) => {
  const { data, loading, error } = useFetchData(`/activitycard/${config.id}`);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Not Able to fetch data</div>;
  if (!data) return <div>No data available</div>;
  const { device, position_block_config } = data;
  if (data.is_positioned_block) {
    return (
      <div className={`overflow_hidden ${classes}`}>
        <PositionedScreen
          layoutConfig={
            device === "desktop" ? position_block_config || [] : convertGridToPixels(position_block_config || [], 4)
          }
          screenWidth={device === "desktop" ? 1600 : 512}
          type={"view"}
        />
      </div>
    );
  } else {
    return null;
  }
};

export default ActivityCardPreview;
